import React, { useEffect, useState } from 'react';

function dataUrlToBlobUrl(dataUrl) {
  if (!dataUrl?.startsWith('data:application/pdf')) return null;
  const base64 = dataUrl.slice(dataUrl.indexOf(',') + 1);
  const byteStr = atob(base64);
  const len = byteStr.length;
  const buf = new ArrayBuffer(len);
  const arr = new Uint8Array(buf);
  for (let i = 0; i < len; i++) arr[i] = byteStr.charCodeAt(i);
  const blob = new Blob([buf], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

export default function ReceiptPdfViewer({ file, height = 987 }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!file) return;
    if (file.startsWith('data:application/pdf')) {
      setUrl(dataUrlToBlobUrl(file));
    } else if (file.startsWith('blob:') || file.startsWith('http')) {
      setUrl(file);
    }
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [file]);

  if (!file) return null;

  if (file.startsWith('data:image/')) {
    return <img src={file} alt="preview" className="w-100 p-d-block p-mb-4" />;
  }

  if (!url) return <div>Nem támogatott formátum</div>;

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return isSafari ? (
    <iframe src={url} width="100%" height={height} className="p-d-block p-mb-4" />
  ) : (
    <object data={url} type="application/pdf" width="100%" height={height} className="p-d-block p-mb-4" />
  );
}
